import React from "react";
import PropTypes from "prop-types";
import { Search, X } from "lucide-react";

import { Input } from "components/ui/input";
import { Button } from "components/ui/button";

const Toolbar = ({ searchTerm, setSearchTerm }) => {
  function handleSubmit(event) {
    event.preventDefault();
  }

  function handleClear() {
    setSearchTerm("");
  }

  function handleChange(event) {
    setSearchTerm(event.target.value);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex w-full flex-col gap-2 rounded-lg border border-border bg-card p-4 shadow-sm md:flex-row md:items-center"
    >
      <label htmlFor="organization-search" className="text-sm font-medium text-muted-foreground md:min-w-[160px]">
        Search organizations
      </label>
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden />
        <Input
          id="organization-search"
          type="search"
          value={searchTerm}
          onChange={handleChange}
          placeholder="Search by name or id..."
          className="pl-9"
        />
        {searchTerm && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={handleClear}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground"
            aria-label="Clear search"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </form>
  );
};

Toolbar.propTypes = {
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func.isRequired,
};

export default Toolbar;
